export const VMS_VIEW_MODES = [
  { name: 'single', panelCount: 1, label: 'Single camera view' },
  { name: 'double', panelCount: 2, label: 'Two camera view' },
  { name: 'quad', panelCount: 4, label: 'Four camera view' },
];

export const VMS_MAX_CAMERA_PANELS = 4;
export const VMS_SELECTION_COOKIE = 'overwatch-vms';
export const VMS_FEED_RUNTIME_CUTOFF_MS = 5 * 60 * 1000;
